import './study-plan-overlay.css';

import { DsIcon } from '@descomplica/design-system-react';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import { useParams } from 'react-router-dom';

import { ClassroomViewModel } from '@/presentation/screens/classroom/classroom.vm';
import { Button } from '@/presentation/shared-components/button/button';

const StudyPlanOverlay: React.FC = () => {
  const vm = useViewModel(ClassroomViewModel);
  const { weekOrder } = useParams();

  const handleWatchAgain = () => {
    vm.handleWatchAgain();
    vm.toggleCompletedStudyplanOverlay();
  };

  const handleContinueStudyPlan = () => {
    vm.handleContinueStudyPlan(weekOrder);
  };

  return (
    <div className="study-plan-overlay">
      <div className="study-plan-overlay-content">
        <h1 className="study-plan-overlay-text">
          Mandando bem! <br /> Você completou as aulas da semana {weekOrder}
          <br /> do curso {`"${vm.classroom.course.name}"`}
        </h1>
        <div className="study-plan-overlay-buttons">
          <Button
            className="btn outline-black-white spaced"
            ariaLabel=""
            onClick={vm.toggleCompletedStudyplanOverlay}
          >
            Continuar neste curso
          </Button>
          <Button className="btn green spaced" ariaLabel="" onClick={handleContinueStudyPlan}>
            Seguir o planejamento
          </Button>
        </div>
        <Button className="icon-button" ariaLabel="" onClick={handleWatchAgain}>
          <DsIcon image="replay-video" color="neutral-00" />
          Assistir novamente
        </Button>
      </div>
      <div className="study-plan-overlay-background" />
    </div>
  );
};

export default observer(StudyPlanOverlay);
